<template>
  <a-modal
    ref="createModal"
    title="新建工作日历"
    :width="850"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="loading">
      <a-form
        :form="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="日历名称">
          <a-input v-decorator="['calendarName', { rules: [{ required: true, message: '请输入日历名称' }] }]" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="说明">
          <a-input v-decorator="['description']" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="复制已有日历">
          <a-select v-decorator="['copyCalendarId']" @change="copyCalendarIdOnChange">
            <a-select-option v-for="(item) in calendarIdList" :key="item.realValue">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="班次名称">
          <a-select v-decorator="['shiftsHeadIdList', { rules: [{ required: true, message: '请选择班次名称' }] }]" mode="multiple">
            <a-select-option v-for="(item) in shiftsHeadIdListOption" :key="item.realValue">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="工作日模式" prop="daysValues">
          <a-checkbox-group v-model="daysValues" :options="plainOptions" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { apiRoutingCalendarId, apiRoutingCalendarAdd } from '@/api/mes/calendar/workCalendar'
export default {
  props: {
    calendarIdList: {
      type: Array,
      default: () => {
        return []
      }
    },
    shiftsHeadIdListOption: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      loading: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      // 表单参数
      form: this.$form.createForm(this),
      daysValues: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'], // 工作日模式-默认值
      // 工作日模式
      plainOptions: [
        { label: '星期一', value: 'monday' },
        { label: '星期二', value: 'tuesday' },
        { label: '星期三', value: 'wednesday' },
        { label: '星期四', value: 'thursday' },
        { label: '星期五', value: 'friday' },
        { label: '星期六', value: 'saturday' },
        { label: '星期日', value: 'sunday' }
      ]
    }
  },
  created () {},
  methods: {
    // 复制已有日历
    copyCalendarIdOnChange (val) {
      apiRoutingCalendarId(val).then(res => {
        if (res.data && res.data.bomRoutingShiftsHeadVOList && res.data.bomRoutingShiftsHeadVOList.length > 0) {
          const arr = []
          res.data.bomRoutingShiftsHeadVOList.forEach(element => {
            arr.push(element.id)
          });
          this.form.setFieldsValue({
            shiftsHeadIdList: arr
          })
        } else {
          this.form.setFieldsValue({
            shiftsHeadIdList: []
          })
        }
        if (res.data) {
          const arr1 = []
          if (res.data.monday === "Y") {
            arr1.push("monday")
          }
          if (res.data.tuesday === "Y") {
            arr1.push("tuesday")
          }
          if (res.data.wednesday === "Y") {
            arr1.push("wednesday")
          }
          if (res.data.thursday === "Y") {
            arr1.push("thursday")
          }
          if (res.data.friday === "Y") {
            arr1.push("friday")
          }
          if (res.data.saturday === "Y") {
            arr1.push("saturday")
          }
          if (res.data.sunday === "Y") {
            arr1.push("sunday")
          }
          this.daysValues = arr1
        }
      })
    },
    show () {
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.visible = false
      this.reset()
    },
    // 保存
    confirm () {
      // 工作日模式
      const obj = {
        monday: "N",
        tuesday: "N",
        wednesday: "N",
        thursday: "N",
        friday: "N",
        saturday: "N",
        sunday: "N"
      }
      this.daysValues.forEach(element => {
        obj[element] = "Y"
      });

      this.confirmLoading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          apiRoutingCalendarAdd({ ...this.form.getFieldsValue(), ...obj }).then(response => {
            if (response.code === 200) {
              this.$message.success('新增成功')
              // 关闭本组件
              this.visible = false
              // 调用外部刷新列表方法
              this.$emit('handle-success')
              // 刷新表单
              this.reset()
              this.confirmLoading = false
              this.$router.push({ path: `/workCalendar/detail/${response.data}` })
            } else {
              this.$message.error(response.msg)
              this.confirmLoading = false
            }
          }).catch(e => {
            this.confirmLoading = false
          })
        } else {
          return (this.confirmLoading = false)
        }
      });
    },
    // 表单重置
    reset () {
      this.form.resetFields()
    }
  }
}
</script>
